var $79e778f6a71e6e7d$exports = {};
$79e778f6a71e6e7d$exports = {
    "decrease": (args)=>`Zn\xed\u{17E}i\u{165} ${args.fieldLabel}`,
    "increase": (args)=>`Zv\xfd\u{161}i\u{165} ${args.fieldLabel}`,
    "numberField": `\u{10C}\xedseln\xe9 pole`
};


export {$79e778f6a71e6e7d$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
